import { FC } from "react";
import useContractation from "@/components/Contractation/hooks/useContractation";
import { ListGroup, ListItem } from "@gisce/oficina-virtual-components";
import { AddBox } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useNavigationItemsContext } from "../../useNavigationItemsContext";

const ContractationListItems: FC = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentPath } = useNavigationItemsContext();
  const { activeContractations, isContractationPath } = useContractation();

  return (activeContractations.num > 1 ?
    <ListGroup
      icon={<AddBox />}
      titleLabel={t('common:text.new_customer_title')}
      startOpen={ isContractationPath(currentPath) }
    >
      {activeContractations.types.electricity && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.electricity")})}
          onClick={() => navigate(t(activeContractations.untranslatedURLs.electricity))}
          selected={currentPath === activeContractations.untranslatedURLs.electricity}
        />
      )}
      {activeContractations.types.gas && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.gas")})}
          onClick={() => navigate(t(activeContractations.untranslatedURLs.gas))}
          selected={currentPath === activeContractations.untranslatedURLs.gas}
        />
      )}
      {activeContractations.types.dual && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.dual")})}
          onClick={() => navigate(t(activeContractations.untranslatedURLs.dual))}
          selected={currentPath === activeContractations.untranslatedURLs.dual}
        />
      )}
    </ListGroup>
  :
    <>
      {activeContractations.types.electricity && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.electricity")})}
          onClick={() => navigate(t(activeContractations.untranslatedURLs.electricity))}
          selected={currentPath === activeContractations.untranslatedURLs.electricity}
        />
      )}
      {activeContractations.types.gas && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.gas")})}
          onClick={() => navigate(t(activeContractations.untranslatedURLs.gas))}
          selected={currentPath === activeContractations.untranslatedURLs.gas}
        />
      )}
      {activeContractations.types.dual && (
        <ListItem
          label={t("common:text.contractation_button_title_what", {what: t("common:text.dual")})}
          onClick={() => navigate(t(activeContractations.untranslatedURLs.dual))}
          selected={currentPath === activeContractations.untranslatedURLs.dual}
        />
      )}
    </>
  );
}

export default ContractationListItems;